<template>
  <div class="email-card">

    <div
      class="email-card__content"
      :style="{
        padding: '20px',
        margin: 'auto',
        transformOrigin: '10px 10px',
        fontFamily: 'Arial'
      }"
    >
      <div class="email-card__html">
        <div v-if="body" v-html="body"></div>
        <div v-else v-html="styledWiseEmailExample"></div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex';
import wiseEmailExample from '../../../../../labs/emailExamples/wiseEmailExample.html';

const props = defineProps({
  cardData: Object,
  showCard: Boolean,
});

const store = useStore();

const body = computed(() => store.getters.getCurrentBody());

const styledWiseEmailExample = `
  <style>
    table {
      border-collapse: collapse;
      border-spacing: 0;
      border: none;
      width: 100%;
    }

    td {
      border: none;
    }
  </style>
` + wiseEmailExample;
</script>

<style scoped>
.email-card {
  font-family: 'Arial', sans-serif;
  border: 1px solid #dcdcdc;
  border-radius: 16px;
  max-width: 80vw;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 16px auto;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.email-card__content {
  width: 100%;
  box-sizing: border-box;
}

.email-card__html {
  width: 100%;
}

/*
 * IMPORTANT:
 *
 * We intentionally do NOT intercept clicks here.
 *
 * Normal:
 *
 *     <a href="https://example.com">
 *
 * links are allowed to reach the MAUI WebView_Navigating event.
 *
 * MAUI then decides whether the URL belongs to the Vue app or
 * should be opened externally.
 */
.email-card__html :deep(a) {
  cursor: pointer;
}

.email-card__header {
  background: #0056b3;
  color: #ffffff;
  padding: 16px 24px;
  text-align: left;
}

.email-card__title {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
}

.email-card__body {
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 16px;
}

.email-card__row {
  display: contents;
}

.email-card__label {
  font-weight: bold;
  color: #333333;
  text-align: right;
  padding-right: 16px;
  border-right: 2px solid #f0f0f0;
}

.email-card__value {
  color: #555555;
  padding-left: 16px;
}
</style>